"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param placement
 */
function getVariation(placement) {
    return placement.split('-')[1];
}
exports.default = getVariation;
//# sourceMappingURL=getVariation.js.map